// Style tokens shared by every publisher field group.
//
// Mirrors the look of the wizard's _shared.tsx: subtle borders, rounded-xl,
// uppercase tracked labels, soft slate background. Moved out of
// PublisherForm.tsx so the publisher-facing intake renders identically to the
// internal onboarding form without importing the form itself.

export const inputClass =
  'block w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-[14px] text-slate-900 placeholder:text-slate-300 ' +
  'focus:outline-none focus:border-slate-900 focus:ring-0 transition-colors';

export const readonlyInputClass =
  inputClass + ' bg-slate-50 text-slate-400 cursor-not-allowed';

export const labelClass =
  'block text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500 mb-1.5';

export const helpTextClass = 'mt-1 text-[11px] text-slate-500';
